module.exports = __webpack_public_path__ + "img/bsia.4e5dbb7e.png";